import { UseFormSetValue } from 'react-hook-form';
import { ProviderAddress } from '../data/models/address.model';

export enum ProviderAddressUse {
  Physical = 1,
  Billing = 2,
  Office = 3,
}

class AddressUtils {
  public getProviderAddress(
    addresses: ProviderAddress[] | undefined,
    use: ProviderAddressUse,
  ): ProviderAddress | undefined {
    return (addresses || []).find(
      (addr) =>
        addr.transportationProviderAddressUseID === use &&
        addr.transportationProviderAddressState === 'active',
    );
  }

  public copyBillingToBase(values: any, setValue: UseFormSetValue<any>) {
    setValue('AddressLine1', values.BillingAddressLine1, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('AddressLine2', values.BillingAddressLine2, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('City', values.BillingCity, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('State', values.BillingState, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('ZipCode', values.BillingZipCode, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  }

  public copyDispatchToBilling(values: any, setValue: UseFormSetValue<any>) {
    setValue('BillingAddressLine1', values.AddressLine1, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('BillingAddressLine2', values.AddressLine2, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('BillingCity', values.City, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('BillingState', values.State, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('BillingZipCode', values.ZipCode, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  }

  public copyDispatchToPhysical(values: any, setValue: UseFormSetValue<any>) {
    setValue('PhysicalAddressLine1', values.AddressLine1, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalAddressLine2', values.AddressLine2, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalCity', values.City, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalState', values.State, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalZipCode', values.ZipCode, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  }

  public copyBillingToPhysical(values: any, setValue: UseFormSetValue<any>) {
    setValue('PhysicalAddressLine1', values.BillingAddressLine1, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalAddressLine2', values.BillingAddressLine2, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalCity', values.BillingCity, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalState', values.BillingState, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    setValue('PhysicalZipCode', values.BillingZipCode, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  }
}

const addressUtils = new AddressUtils();

export default addressUtils;
